import React from 'react';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import useExperiencerEditorPlaceholder from '../../hooks/useExperiencerEditorPlaceholder';
import ProductCompatibleLoaders from '../productCompatibleLoaderListing';
import { TCHCompatibleLoadersProps } from '../productCompatibleLoaderListing/types/productCompatibleLoaderListing.types';
import UnreleasedComponent from '../@shared/unreleasedComponent';

const ProductModelDetailCompatibleLoaders = (props: TCHCompatibleLoadersProps) => {
  const apiResponse = isEmptyResponse(props) && props?.fields?.apiData?.items?.length > 0;
  const isPlaceholderShown = useExperiencerEditorPlaceholder(props);

  // Component is unreleased
  if (props?.fields?.isComponentUnreleased) {
    return <UnreleasedComponent />;
  }

  //  star node opened directly in EE
  if (isPlaceholderShown) {
    return (
      <ExperienceEditorComponentPlaceholder image={props?.fields?.itemData?.thumbnail} componentName={props?.rendering?.componentName} />
    );
  }
  // not opened from star node
  // data missing when navigating via from products node
  if (!apiResponse && isEditorActive()) {
    return <EmptyApiDataMessage componentName={props?.rendering?.componentName} />;
  }

  // No data and not in EE
  if (!apiResponse && !isPlaceholderShown && !isEditorActive()) {
    return null;
  }
  return <ProductCompatibleLoaders {...props} id={props?.rendering?.componentName} isModelLoders={true} />;
};
export default ProductModelDetailCompatibleLoaders;
